import { GoogleDriveProvider } from '../providers/google-drive/google-drive-provider.js';
import { LocalStorageProvider } from '../providers/local/local-provider.js';
import { DesktopDiskProvider, getDesktopBridgeStorage, } from '../providers/desktop/desktop-disk-provider.js';
import { registerProvider } from './provider-factory.js';
// 'local' means "this machine": inside SKJV Desktop that is real files under
// the user's storage root (PRD §5a) via the preload bridge; in a browser it
// stays localStorage. Same id, so existing config enables either untouched.
registerProvider('local', () => getDesktopBridgeStorage() ? new DesktopDiskProvider() : new LocalStorageProvider());
registerProvider('google-drive', (subConfig) => {
    const cfg = subConfig;
    if (!cfg.clientId) {
        throw new Error('google-drive: clientId is required');
    }
    return new GoogleDriveProvider({
        clientId: cfg.clientId,
        scope: cfg.scope,
        folderId: cfg.folderId,
    });
});
//# sourceMappingURL=built-in-registrations.js.map